import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "segment-tail" }
const _hoisted_2 = { class: "option-buttons" }
const _hoisted_3 = {
  id: "info-items",
  class: "info-items"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MatchPercentage = _resolveComponent("MatchPercentage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MatchPercentage, {
          modelValue: _ctx.translationSegment,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.translationSegment) = $event))
        }, null, 8, ["modelValue"]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentType(_ctx.translationSegment)), {
          modelValue: _ctx.translationSegment,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.translationSegment) = $event))
        }, null, 8, ["modelValue"]))
      ])
    ])
  ]))
}